import { defaultVendorType, makeAppKey, makeVendor, makeVendorFromMarketplaceApp } from '@atlassian/mpac-api-client';
import { UrlUtils } from '@atlassian/mpac-utils';
import { Record } from 'immutable';
const makeAppDistribution = Record({
  downloadCount: 0,
  installationCount: 0,
  isPreinstalled: false,
  isPreinstalledInAnyHosting: false
});
export const makeAppDistributionFromMarketplaceApp = marketplaceApp => {
  var _marketplaceApp$_embe;
  const {
    downloads,
    totalInstalls,
    bundled,
    bundledCloud
  } = ((_marketplaceApp$_embe = marketplaceApp._embedded) === null || _marketplaceApp$_embe === void 0 ? void 0 : _marketplaceApp$_embe.distribution) || {};
  return makeAppDistribution({
    downloadCount: downloads,
    installationCount: totalInstalls,
    isPreinstalled: bundledCloud,
    isPreinstalledInAnyHosting: bundledCloud || bundled || false
  });
};
export const makeAppHighlights = Record({
  title: '',
  explanation: '',
  thumbnail: '',
  screenshot: '',
  body: ''
});
export const makeAppScreenShots = Record({
  caption: '',
  screenshot: ''
});
export const makeAppDisplayDetails = Record({
  key: makeAppKey(''),
  icon: undefined,
  metadata: {},
  origin: undefined,
  name: '',
  version: undefined,
  vendor: makeVendor(),
  privacyPolicy: undefined,
  eula: undefined,
  tagLine: '',
  youtubeId: undefined,
  heroImage: undefined,
  highlights: [],
  screenshots: [],
  moreDetails: undefined,
  isConnectApp: false,
  paymentModel: undefined,
  ratings: {
    avgStars: 0,
    numRatings: 0
  },
  ecosystemCloudAppId: '',
  programs: undefined,
  distribution: makeAppDistribution(),
  tags: undefined
});
export const makeMarketplaceAppDisplayDetails = value => value;
export const makeSPIAppDisplayDetails = value => value;
const getImageUrl = links => links && links._links ? (links._links.highRes || links._links.unscaled || links._links.image).href : undefined;
const getHighlights = highlights => highlights ? highlights.map(highlight => {
  var _highlight$_embedded, _highlight$_embedded2;
  return makeAppHighlights({
    title: highlight.title,
    explanation: highlight.explanation,
    body: highlight.body,
    thumbnail: getImageUrl((_highlight$_embedded = highlight._embedded) === null || _highlight$_embedded === void 0 ? void 0 : _highlight$_embedded.thumbnail),
    screenshot: getImageUrl((_highlight$_embedded2 = highlight._embedded) === null || _highlight$_embedded2 === void 0 ? void 0 : _highlight$_embedded2.screenshot)
  });
}) : [];
const getScreenshots = screenshots => screenshots ? screenshots.map(highlight => {
  var _highlight$_embedded3;
  return makeAppScreenShots({
    caption: highlight.caption,
    screenshot: getImageUrl((_highlight$_embedded3 = highlight._embedded) === null || _highlight$_embedded3 === void 0 ? void 0 : _highlight$_embedded3.image)
  });
}) : [];
export const makeSPIAppDisplayDetailsFromSPIAddonDisplayDetails = addonDisplayDetails => makeAppDisplayDetails({
  key: makeAppKey(addonDisplayDetails.key),
  icon: addonDisplayDetails.icon,
  metadata: addonDisplayDetails.metadata,
  origin: addonDisplayDetails.origin,
  name: addonDisplayDetails.name,
  version: addonDisplayDetails.version,
  vendor: makeVendor({
    name: addonDisplayDetails.vendor,
    link: UrlUtils.validateSafeAbsoluteUrl(addonDisplayDetails.vendorLink),
    // Eventually VendorType should not be optional in SPI AddonDisplayDetails, we should update marketplace-spi after DAC-3300
    vendorType: addonDisplayDetails.vendorType || defaultVendorType
  }),
  privacyPolicy: UrlUtils.validateSafeAbsoluteUrl(addonDisplayDetails.privacyPolicy),
  eula: UrlUtils.validateSafeAbsoluteUrl(addonDisplayDetails.eula),
  ecosystemCloudAppId: addonDisplayDetails.ecosystemCloudAppId,
  tags: addonDisplayDetails.tags
});
export const makeMarketplaceAppDisplayDetailsFromMarketplaceApp = _ref => {
  var _marketplaceApp$_embe2, _marketplaceApp$_embe3, _marketplaceApp$_embe4, _marketplaceApp$_embe5, _marketplaceApp$vendo, _marketplaceApp$_embe6, _marketplaceApp$_embe7, _marketplaceApp$_embe8, _marketplaceApp$_embe9, _marketplaceApp$_embe10, _marketplaceApp$_embe11, _marketplaceApp$_embe12, _marketplaceApp$_embe13, _marketplaceApp$_embe14, _marketplaceApp$_embe15, _marketplaceApp$_embe16, _marketplaceApp$_embe17, _marketplaceApp$_embe18, _marketplaceApp$_embe19, _marketplaceApp$_embe20, _marketplaceApp$_embe21, _marketplaceApp$_embe22, _marketplaceApp$_embe23, _marketplaceApp$_embe24, _marketplaceApp$_embe25, _marketplaceApp$_embe26, _marketplaceApp$_embe27, _marketplaceApp$_embe28, _marketplaceApp$_embe29, _marketplaceApp$_embe30, _marketplaceApp$_embe31, _marketplaceApp$_embe32, _marketplaceApp$_embe33;
  let {
    mpacBaseUrl,
    marketplaceApp
  } = _ref;
  return makeMarketplaceAppDisplayDetails(makeAppDisplayDetails({
    key: marketplaceApp.key,
    icon: (_marketplaceApp$_embe2 = marketplaceApp._embedded) === null || _marketplaceApp$_embe2 === void 0 ? void 0 : (_marketplaceApp$_embe3 = _marketplaceApp$_embe2.logo) === null || _marketplaceApp$_embe3 === void 0 ? void 0 : _marketplaceApp$_embe3._links.image.href,
    origin: 'marketplace',
    name: marketplaceApp.name,
    vendor: makeVendorFromMarketplaceApp({
      marketplaceApp,
      mpacBaseUrl
    }),
    version: (_marketplaceApp$_embe4 = marketplaceApp._embedded) === null || _marketplaceApp$_embe4 === void 0 ? void 0 : (_marketplaceApp$_embe5 = _marketplaceApp$_embe4.version) === null || _marketplaceApp$_embe5 === void 0 ? void 0 : _marketplaceApp$_embe5.name,
    privacyPolicy: UrlUtils.validateSafeAbsoluteUrl((_marketplaceApp$vendo = marketplaceApp.vendorLinks) === null || _marketplaceApp$vendo === void 0 ? void 0 : _marketplaceApp$vendo.privacy),
    eula: UrlUtils.validateSafeAbsoluteUrl((_marketplaceApp$_embe6 = marketplaceApp._embedded) === null || _marketplaceApp$_embe6 === void 0 ? void 0 : (_marketplaceApp$_embe7 = _marketplaceApp$_embe6.version) === null || _marketplaceApp$_embe7 === void 0 ? void 0 : (_marketplaceApp$_embe8 = _marketplaceApp$_embe7.vendorLinks) === null || _marketplaceApp$_embe8 === void 0 ? void 0 : _marketplaceApp$_embe8.eula),
    tagLine: marketplaceApp.tagLine,
    youtubeId: (_marketplaceApp$_embe9 = marketplaceApp._embedded) === null || _marketplaceApp$_embe9 === void 0 ? void 0 : (_marketplaceApp$_embe10 = _marketplaceApp$_embe9.version) === null || _marketplaceApp$_embe10 === void 0 ? void 0 : _marketplaceApp$_embe10.youtubeId,
    heroImage: getImageUrl((_marketplaceApp$_embe11 = marketplaceApp._embedded) === null || _marketplaceApp$_embe11 === void 0 ? void 0 : (_marketplaceApp$_embe12 = _marketplaceApp$_embe11.version) === null || _marketplaceApp$_embe12 === void 0 ? void 0 : (_marketplaceApp$_embe13 = _marketplaceApp$_embe12._embedded) === null || _marketplaceApp$_embe13 === void 0 ? void 0 : _marketplaceApp$_embe13.hero),
    highlights: getHighlights((_marketplaceApp$_embe14 = marketplaceApp._embedded) === null || _marketplaceApp$_embe14 === void 0 ? void 0 : (_marketplaceApp$_embe15 = _marketplaceApp$_embe14.version) === null || _marketplaceApp$_embe15 === void 0 ? void 0 : (_marketplaceApp$_embe16 = _marketplaceApp$_embe15._embedded) === null || _marketplaceApp$_embe16 === void 0 ? void 0 : _marketplaceApp$_embe16.highlights),
    screenshots: getScreenshots((_marketplaceApp$_embe17 = marketplaceApp._embedded) === null || _marketplaceApp$_embe17 === void 0 ? void 0 : (_marketplaceApp$_embe18 = _marketplaceApp$_embe17.version) === null || _marketplaceApp$_embe18 === void 0 ? void 0 : (_marketplaceApp$_embe19 = _marketplaceApp$_embe18._embedded) === null || _marketplaceApp$_embe19 === void 0 ? void 0 : _marketplaceApp$_embe19.screenshots),
    moreDetails: (_marketplaceApp$_embe20 = marketplaceApp._embedded) === null || _marketplaceApp$_embe20 === void 0 ? void 0 : (_marketplaceApp$_embe21 = _marketplaceApp$_embe20.version) === null || _marketplaceApp$_embe21 === void 0 ? void 0 : (_marketplaceApp$_embe22 = _marketplaceApp$_embe21.text) === null || _marketplaceApp$_embe22 === void 0 ? void 0 : _marketplaceApp$_embe22.moreDetails,
    isConnectApp: (_marketplaceApp$_embe23 = marketplaceApp._embedded) === null || _marketplaceApp$_embe23 === void 0 ? void 0 : (_marketplaceApp$_embe24 = _marketplaceApp$_embe23.version) === null || _marketplaceApp$_embe24 === void 0 ? void 0 : _marketplaceApp$_embe24.deployment.connect,
    paymentModel: (_marketplaceApp$_embe25 = marketplaceApp._embedded) === null || _marketplaceApp$_embe25 === void 0 ? void 0 : (_marketplaceApp$_embe26 = _marketplaceApp$_embe25.version) === null || _marketplaceApp$_embe26 === void 0 ? void 0 : _marketplaceApp$_embe26.paymentModel,
    ratings: {
      avgStars: ((_marketplaceApp$_embe27 = marketplaceApp._embedded) === null || _marketplaceApp$_embe27 === void 0 ? void 0 : (_marketplaceApp$_embe28 = _marketplaceApp$_embe27.reviews) === null || _marketplaceApp$_embe28 === void 0 ? void 0 : _marketplaceApp$_embe28.averageStars) || 0,
      numRatings: ((_marketplaceApp$_embe29 = marketplaceApp._embedded) === null || _marketplaceApp$_embe29 === void 0 ? void 0 : (_marketplaceApp$_embe30 = _marketplaceApp$_embe29.reviews) === null || _marketplaceApp$_embe30 === void 0 ? void 0 : _marketplaceApp$_embe30.count) || 0
    },
    ecosystemCloudAppId: (_marketplaceApp$_embe31 = marketplaceApp._embedded) === null || _marketplaceApp$_embe31 === void 0 ? void 0 : (_marketplaceApp$_embe32 = _marketplaceApp$_embe31.version) === null || _marketplaceApp$_embe32 === void 0 ? void 0 : (_marketplaceApp$_embe33 = _marketplaceApp$_embe32.cloud) === null || _marketplaceApp$_embe33 === void 0 ? void 0 : _marketplaceApp$_embe33.appId,
    programs: marketplaceApp.programs,
    distribution: makeAppDistributionFromMarketplaceApp(marketplaceApp)
  }));
};